import 'react-app-polyfill/ie11';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import 'react-notifications/lib/notifications.css';
import { createGenerateClassName, StylesProvider, ThemeProvider } from '@material-ui/core/styles';
import 'EventTracking';
import { unregister } from 'registerServiceWorker';
import { store } from 'State/store';
import { WindowContextProvider } from 'Context/WindowContext';
import { SnackbarContextProvider } from 'Context/SnackbarContext';
import LayoutContextProvider from 'Context/LayoutContext';
import { pdfjs } from 'react-pdf';
import Home from 'Views/Home';
import { FDStyleProvider } from '@facet-wealth/design';
import { NavContextProvider } from 'Context/NavContext';
import ContentRouter from 'Views/Home/Content';
import { importYodleeFastLink } from 'Helpers/External';
import theme from './Theme';
import './index.css';
import './reset.css'; // TODO: Remove this ASAP. It's just used to counter global styles introduced from other stylesheets.
import Sentry from './Integrations/Sentry';
import ErrorBoundary from './Errors/ErrorBoundary';

import './Packages/FacetRest/FacetRestConfiguration';
import './Packages/FacetDesign/FacetDesignConfiguration';

// If this browser tab ever needs yodlee, it would be nice if it's already loaded up by then
importYodleeFastLink();

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;
Sentry.init();

const generateClassName = createGenerateClassName({
  productionPrefix: 'c',
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <FDStyleProvider>
    <StylesProvider generateClassName={generateClassName}>
      <ThemeProvider theme={theme}>
        <ErrorBoundary>
          <NavContextProvider>
            <LayoutContextProvider>
              <Provider store={store}>
                <WindowContextProvider>
                  <SnackbarContextProvider>
                    <Home Component={ContentRouter} />
                  </SnackbarContextProvider>
                </WindowContextProvider>
              </Provider>
            </LayoutContextProvider>
          </NavContextProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </StylesProvider>
  </FDStyleProvider>,
);

unregister();
